import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

window.addEventListener('DOMContentLoaded', () => {
	// Navigation Hamburger
	let nav = document.querySelector('nav')
	let firstOpen = true
	document.getElementById('hamburger')?.addEventListener('click', function (e) {
		nav.classList.toggle('mobileOpen')
		if (firstOpen) {
			nav.classList.remove('mobileCLose')
			firstOpen = false
			return
		}
		nav.classList.toggle('mobileClose')
	})

	//Navigation Animate on Scroll
	let mm = gsap.matchMedia()
	let navbar = document.querySelector('.navbar')
	mm.add('(min-width: 1200px)', () => {
		const showAnim = gsap
			.from('.navbar', {
				yPercent: -100,
				paused: true,
				duration: 0.2,
			})
			.progress(1)

		ScrollTrigger.create({
			start: 'top -50',
			end: 99999,
			onUpdate: (self) => {
				if (self.direction === -1) {
					showAnim.play()
					navbar.classList.add('pointer-events')
				} else {
					showAnim.reverse()
					navbar.classList.remove('pointer-events')
				}
			},
		})

		ScrollTrigger.create({
			start: 'top -250',
			end: 99999,
			toggleClass: { className: 'navbar--scrolled', targets: '.navbar' },
		})
	})
})
